import { useCallback } from 'react';

import { CALENDAR_API_PATHS } from '@/app/(main)/calendar/consts/calendar-api';
import { parseCalendarTaskResponse } from '@/app/(main)/calendar/utils/parseCalendarTaskResponse';
import { useFetch } from '@/hooks/useFetch';
import type { ClientTaskData, UpdateClientTaskResponse } from '@/types/clientTasksApiTypes';

export function useFetchCalendarTaskById() {
  const { doFetch } = useFetch<void, UpdateClientTaskResponse>();

  return useCallback(
    async (taskId: string): Promise<ClientTaskData | null> => {
      const response = await doFetch(CALENDAR_API_PATHS.TASK_DETAIL(taskId), {
        suppressErrorToast: true,
      });
      return parseCalendarTaskResponse(response);
    },
    [doFetch]
  );
}
